package com.dotdrives.web.pages.drives

import com.dotdrives.design.DotColors
import react.FC
import react.Props
import react.dom.html.ReactHTML.style

private val drivesStyles = """
    .drives-load-more{width:100%;padding:12px;border:1px solid var(--dot-border,#ddd);border-radius:8px;background:white;cursor:pointer;color:#5B4AA8;font:inherit}
/* History is modal: keep its heading and close control above the z-index:90 support banner. */
.drives-detail-backdrop.drives-history-backdrop{z-index:100}
.drives-detail-panel.drives-history-panel{width:min(800px,100vw);overflow-y:auto}
.drives-history-panel .drives-detail-head{background:#f5f3fa;color:#222D32;flex-shrink:0}
.drives-history-panel .drives-completed-card{flex-shrink:0}
.drives-history-panel .drives-completed-row{width:100%;text-align:left;appearance:none;border:0;border-bottom:1px solid #E4E8EC;background:white;color:#222D32;font:inherit;cursor:pointer}
.drives-history-panel .drives-completed-row:hover{background:#F5F3FA}
.drives-history-panel .drives-completed-row:focus-visible{outline:3px solid #4696EC;outline-offset:-3px;background:#F5F3FA}
.drives-history-panel .drives-detail-head button{min-height:44px;padding:9px 14px;border:1px solid #D8D5E0;border-radius:8px;background:white;color:#222D32;font:inherit;cursor:pointer}
.drives-history-panel .drives-detail-head button:hover:not(:disabled){background:#ECE8F5}
.drives-history-panel .drives-detail-head button:disabled{opacity:.55;cursor:default}
.drives-history-panel .drives-detail-head button:focus-visible{outline:3px solid #4696EC;outline-offset:2px}
.drives-history-panel .drives-history-close{margin-left:auto;flex-shrink:0}
.drives-history-panel .drives-completed-name{overflow-wrap:anywhere}
@media(max-width:500px){.drives-history-panel .drives-completed-row{flex-wrap:wrap}.drives-history-panel .drives-completed-copy{min-width:60%}}
.drives-history-panel .drives-detail-head{display:flex;gap:12px;flex-wrap:wrap}
.drives-history-panel .drives-detail-head p{width:100%;margin:0;font-size:13px;color:#595665}
.drives-history-panel input,.drives-history-panel select{padding:9px;border:1px solid #d8d5e0;border-radius:6px;max-width:100%}
.drives-page { min-height: calc(100vh - 118px); }
    .drives-header { display: flex; flex-direction: column; gap: 12px; margin-bottom: 16px; }
    .drives-header-row { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
    .drives-title-row { min-width: 0; max-width: 100%; display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
    .drives-title { font-family: 'Quicksand', sans-serif; font-size: 22px; font-weight: 700; }
    .drives-count { margin-left: 2px; color: var(--dot-muted); font-family: 'IBM Plex Mono', monospace; font-size: 13px; font-weight: 400; }
    .drives-template-select {
      min-width: 160px; max-width: min(360px, 100%); min-height: 42px; padding: 8px 36px 8px 14px; border: 1px solid #CBD2D7; border-radius: 10px;
      color: #222D32; background: white; font-size: 14px; font-weight: 800; cursor: pointer;
    }
    .drives-view-toggle { display: flex; padding: 3px; border-radius: 99px; background: #EFF1F4; }
    .drives-view-toggle-btn {
      padding: 6px 16px; border-radius: 99px; color: var(--dot-muted); background: transparent;
      cursor: pointer; font-size: 13px; font-weight: 800;
    }
    .drives-view-toggle-btn-active { color: #222D32; background: white; box-shadow: 0 1px 4px rgba(34,45,50,.12); }
    .drives-topbar-actions { margin-left: auto; display: flex; align-items: center; gap: 10px; }
    .drives-topbar-button { min-height: 38px; padding: 8px 16px; font-size: 13px; }
    .drives-search-row { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; position: relative; }
    .drives-search {
      width: 230px; min-height: 38px; padding: 8px 14px; border: 1px solid transparent;
      border-radius: 99px; outline: none; color: #222D32; background: white; font-size: 13px;
    }
    .drives-search:focus { border-color: #F26223; box-shadow: 0 0 0 2px #FDE5DA; }
    .drives-filter-button {
      min-height: 32px; padding: 5px 13px; border: 1.5px solid #D6DBE0; border-radius: 99px;
      color: #5A6870; background: white; cursor: pointer; font-size: 12px; font-weight: 800;
    }
    .drives-filter-button-active { border-color: #F26223; color: var(--dot-action-text); background: #FDE5DA; }
    .drives-financials-row {
      margin-left: auto; display: flex; gap: 18px; font-family: 'IBM Plex Mono', monospace;
      font-size: 12px; color: #5A6870;
    }
    .drives-financials-row b { font-weight: 500; }
    .drives-inline-banner { margin-bottom: 12px; }

    .drives-board { flex: 1; overflow: auto; padding-bottom: 8px; }
    .drives-board-grid { display: grid; grid-auto-flow: column; grid-auto-columns: 264px; gap: 14px; align-items: start; }
    .drives-column { padding: 12px; border-radius: 14px; background: #E7EAEE; }
    .drives-column-head { display: flex; align-items: center; gap: 8px; padding: 2px 4px 10px; }
    .drives-column-dot { width: 10px; height: 10px; border-radius: 50%; flex: 0 0 auto; }
    .drives-column-name { font-family: 'Quicksand', sans-serif; font-weight: 700; font-size: 15px; min-width: 0; overflow-wrap: anywhere; }
    .drives-column-count { font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: var(--dot-muted); }
    .drives-column-total { margin-left: auto; font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: #5A6870; font-weight: 500; }
    .drives-column-add { flex: 0 0 28px; width: 28px; height: 28px; padding: 0; border: 1px solid #B7C1C7; border-radius: 7px; background: transparent; color: #34444D; font-size: 21px; line-height: 1; cursor: pointer; }
    .drives-column-add:hover { background: white; border-color: #7E8E98; }
    .drives-column-add:focus-visible { outline: 2px solid #5B4AA8; outline-offset: 2px; }
    .drives-board-no-matches { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; margin-bottom: 14px; font-size: 13px; color: #5A6870; }
    .drives-board-no-matches button { padding: 6px 10px; border: 1px solid #B7C1C7; border-radius: 7px; background: white; color: #34444D; cursor: pointer; }
    .drives-column-cards { display: flex; flex-direction: column; gap: 10px; }
    .drives-card { position: relative; width: 100%; transition: transform 160ms ease; }
    .drives-card:hover { transform: translateY(-2px); }
    .drives-card-open {
      display: block; width: 100%; padding: 13px 14px; border: 1px solid #E4E8EC; border-radius: 12px;
      color: #222D32; background: white; cursor: pointer; text-align: left; box-shadow: 0 1px 3px rgba(34,45,50,.06);
      transition: box-shadow 160ms ease;
    }
    .drives-card:hover .drives-card-open { box-shadow: 0 8px 22px rgba(34,45,50,.14); }
    .drives-card-open:focus-visible, .drives-card-move-select:focus-visible,
    .drives-filter-button:focus-visible, .drives-page button:focus-visible,
    .drives-dialog input:focus-visible, .drives-dialog select:focus-visible, .drives-dialog textarea:focus-visible {
      outline: 2px solid var(--dot-focus); outline-offset: 2px;
    }
    .drives-card-head { margin-bottom: 6px; padding-right: 76px; }
    .drives-card-title { font-weight: 800; font-size: 14px; line-height: 1.3; }
    .drives-card-move-select {
      position: absolute; top: 13px; right: 14px; z-index: 1; max-width: 60px; border: none;
      color: #F26223; background: transparent; cursor: pointer; pointer-events: none;
      font-size: 11px; font-weight: 800; font-family: inherit; opacity: 0; transition: opacity 120ms ease;
    }
    .drives-card:hover .drives-card-move-select, .drives-card:focus-within .drives-card-move-select {
      opacity: 1; pointer-events: auto;
    }
    /* Coarse pointers (touch) never fire :hover, so the picker would otherwise stay
       invisible-but-tappable in that top-right corner -- make it visible there instead. */
    @media (hover: none) {
      .drives-card-move-select { opacity: 1; pointer-events: auto; }
    }
    .drives-card-giver { font-size: 12px; color: var(--dot-muted); margin-bottom: 9px; }
    .drives-card-pills { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin-bottom: 9px; }
    .drives-card-target { background: #EFF1F4; color: #5A6870; font-size: 11px; font-weight: 800; padding: 3px 9px; border-radius: 99px; }
    .drives-card-foot { display: flex; justify-content: space-between; align-items: center; }
    .drives-card-avatar-age { display: flex; align-items: center; gap: 6px; }
    .drives-card-avatar {
      width: 22px; height: 22px; display: flex; flex: 0 0 auto; align-items: center; justify-content: center;
      border-radius: 50%; color: white; background: #4696EC; font-size: 9.5px; font-weight: 800;
    }
    .drives-card-age { font-family: 'IBM Plex Mono', monospace; font-size: 11px; }
    .drive-age-today { color: var(--dot-positive); }
    .drive-age-normal { color: var(--dot-muted); }
    .drive-age-stale { color: var(--dot-action-text); }
    .drive-age-critical { color: #C22C25; }
    .drives-card-amount { font-family: 'IBM Plex Mono', monospace; font-size: 12.5px; font-weight: 500; }
    .drives-card-progress { margin-top: 9px; padding-top: 9px; border-top: 1px dashed #E4E8EC; display: flex; align-items: center; gap: 8px; }
    .drives-card-progress-track { flex: 1; height: 4px; background: #EFF1F4; border-radius: 2px; overflow: hidden; }
    .drives-card-progress-fill { height: 100%; border-radius: 2px; }
    .drives-card-progress-label { font-size: 10.5px; color: var(--dot-muted); font-weight: 800; }
    .drives-column-empty { min-height: 112px; display: grid; place-items: center; padding: 16px 10px; text-align: center; color: ${DotColors.TEXT_SECONDARY}; font-size: 11.5px; font-weight: 700; }
    .drives-board-skeleton { display: grid; grid-auto-flow: column; grid-auto-columns: 264px; gap: 14px; }
    .drives-board-skeleton-column { padding: 12px; border-radius: 14px; background: #E7EAEE; display: grid; gap: 10px; }

    .drives-empty-wrap { padding: 40px 0; }

    .drives-detail-backdrop {
      position: fixed; z-index: 30; inset: 0; display: flex; justify-content: flex-end;
      background: rgba(34,45,50,.34); animation: drives-fade-in 180ms ease both;
    }
    .drives-detail-panel {
      width: min(460px, 94vw); height: 100%; display: flex; flex-direction: column; overflow: hidden;
      background: white; box-shadow: -16px 0 44px rgba(34,45,50,.16);
      animation: drives-panel-in 300ms cubic-bezier(.22,1,.36,1) both;
    }
    .drives-detail-head { padding: 20px 24px; color: white; background: #222D32; }
    .drives-detail-title-row { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 10px; }
    .drives-detail-title { font-family: 'Quicksand', sans-serif; font-size: 18px; font-weight: 700; }
    .drives-detail-subtitle { margin-top: 2px; font-size: 12px; color: #8FA0AA; }
    .drives-detail-close { align-self: flex-start; color: #8FA0AA; background: transparent; cursor: pointer; font-size: 16px; }
    .drives-detail-pills-row { display: flex; align-items: center; gap: 6px; margin-bottom: 14px; flex-wrap: wrap; }
    .drives-detail-move-button {
      margin-left: auto; background: var(--dot-action); color: white; font-size: 11.5px; font-weight: 800;
      padding: 6px 14px; border-radius: 99px; cursor: pointer;
    }
    .drives-detail-move-button:disabled { opacity: .5; cursor: not-allowed; }
    .drives-detail-stats-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 7px; }
    .drives-detail-stat { padding: 8px 10px; border-radius: 9px; background: rgba(255,255,255,.07); }
    .drives-detail-stat-label { font-family: 'IBM Plex Mono', monospace; font-size: 8.5px; color: #8FA0AA; letter-spacing: .6px; }
    .drives-detail-stat-value { margin-top: 2px; font-family: 'Quicksand', sans-serif; font-size: 15px; font-weight: 700; }
    .drives-detail-tabs { display: flex; padding: 0 16px; border-bottom: 1px solid #E4E8EC; background: white; overflow-x: auto; }
    .drives-detail-tab {
      padding: 12px 11px 9px; border-bottom: 3px solid transparent; color: var(--dot-muted);
      background: transparent; cursor: pointer; font-size: 12.5px; font-weight: 800; white-space: nowrap;
    }
    .drives-detail-tab-active { border-color: #F26223; color: #222D32; }
    .drives-detail-body { min-height: 0; flex: 1; overflow: auto; padding: 18px 22px 24px; }
    .drives-detail-loading { display: grid; gap: 12px; padding: 22px; }
    .drives-section-label { font-family: 'IBM Plex Mono', monospace; font-size: 10.5px; color: var(--dot-muted); letter-spacing: 1px; margin-bottom: 10px; }
    .drives-task-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 18px; }
    .drives-task-item { display: flex; align-items: center; gap: 11px; border: 1px solid #E4E8EC; background: white; border-radius: 11px; padding: 11px 13px; cursor: pointer; }
    .drives-task-item-done { background: #FBFBFC; }
    .drives-task-item-due { border-color: #FBCEBA; background: #FEF8F6; }
    .drives-task-check {
      width: 22px; height: 22px; border-radius: 7px; border: 2px solid #D6DBE0; color: white; font-size: 11px;
      display: flex; align-items: center; justify-content: center; flex-shrink: 0; background: white;
    }
    .drives-task-check-done { background: #00A65A; border-color: #00A65A; }
    .drives-task-copy { flex: 1; min-width: 0; }
    .drives-task-name { font-weight: 800; font-size: 13px; }
    .drives-task-name-done { color: var(--dot-muted); text-decoration: line-through; }
    .drives-task-meta { font-size: 10.5px; color: var(--dot-muted); margin-top: 1px; }
    .drives-task-category { font-size: 10px; color: var(--dot-muted); background: #F7F8FA; padding: 3px 8px; border-radius: 99px; font-weight: 800; flex: 0 0 auto; }
    .drives-details-list { display: flex; flex-direction: column; gap: 9px; margin-bottom: 18px; }
    .drives-detail-row { display: flex; justify-content: space-between; gap: 12px; font-size: 13px; border-bottom: 1px solid #F2F4F6; padding-bottom: 8px; }
    .drives-detail-key { color: var(--dot-muted); font-weight: 700; }
    .drives-detail-value { font-weight: 800; text-align: right; }
    .drives-file-list { display: flex; flex-direction: column; gap: 7px; margin-bottom: 8px; }
    .drives-file-item { display: flex; align-items: center; gap: 10px; border: 1px solid #E4E8EC; border-radius: 10px; padding: 9px 12px; }
    .drives-file-name { font-weight: 800; font-size: 12.5px; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .drives-file-size { font-family: 'IBM Plex Mono', monospace; font-size: 10px; color: var(--dot-muted); }
    .drives-detail-footer { border-top: 1px solid #E4E8EC; padding: 12px 22px; display: flex; gap: 8px; }
    .drives-footer-pill {
      flex: 1; text-align: center; border: 1.5px solid #E4E8EC; color: #5A6870; font-size: 12.5px;
      font-weight: 800; padding: 10px; border-radius: 99px; background: white; cursor: pointer;
    }
    .drives-footer-pill:hover:not(:disabled) { border-color: #F26223; color: var(--dot-action-text); background: #FDE5DA; }
    .drives-footer-pill:disabled { cursor: not-allowed; opacity: .55; }
    .drives-empty-copy { color: #5A6870; font-size: 13px; padding: 6px 0 14px; }
    .drives-composer { display: grid; gap: 9px; margin-top: 4px; padding-top: 16px; border-top: 1px solid #E4E8EC; }
    .drives-composer input, .drives-composer textarea, .drives-dialog input, .drives-dialog select {
      width: 100%; padding: 10px 12px; border: 1px solid #E4E8EC; border-radius: 10px;
      outline: none; color: #222D32; background: white; font-size: 13px;
    }
    .drives-composer textarea { min-height: 76px; resize: vertical; }
    .drives-composer-actions { display: flex; justify-content: flex-end; }

    .portal-shell .drives-dialog-backdrop { z-index:100; }
    .drives-dialog-backdrop {
      position: fixed; z-index: 40; inset: 0; display: flex; align-items: center; justify-content: center;
      padding: 24px; background: rgba(34,45,50,.34); animation: drives-fade-in 180ms ease both;
    }
    .drives-dialog {
      width: min(540px, 100%); max-height: calc(100vh - 48px); overflow: auto; padding: 26px 30px;
      border-radius: 20px; background: white; box-shadow: 0 24px 80px rgba(34,45,50,.25);
      animation: drives-pop-in 220ms ease both;
    }
    .drives-dialog-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 16px; }
    .drives-dialog-title { font-family: 'Quicksand', sans-serif; font-size: 20px; font-weight: 700; }
    .drives-dialog-close { color: var(--dot-muted); background: transparent; cursor: pointer; font-size: 16px; }
    .drives-form-field { display: grid; gap: 5px; margin-bottom: 14px; }
    .drives-form-label { font-size: 12px; font-weight: 800; }
    .drives-form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
    .drives-giver-search-wrap { position: relative; margin-bottom: 6px; }
    .drives-giver-results { border: 1px solid #E4E8EC; border-radius: 12px; overflow: hidden; margin-bottom: 16px; }
    .drives-giver-result {
      width: 100%; display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-top: 1px solid #F2F4F6;
      background: white; cursor: pointer; text-align: left;
    }
    .drives-giver-result:first-child { border-top: none; }
    .drives-giver-result:hover { background: #FEF8F6; }
    .drives-giver-result-copy { flex: 1; min-width: 0; }
    .drives-giver-result-name { font-weight: 800; font-size: 13px; }
    .drives-giver-result-meta { font-size: 10.5px; color: var(--dot-muted); }
    .drives-giver-create-row { padding: 9px 14px; border-top: 1px solid #F2F4F6; font-size: 12px; font-weight: 800; color: var(--dot-action-text); background: white; cursor: pointer; width: 100%; text-align: left; }
    .drives-selected-giver { display: flex; align-items: center; gap: 10px; padding: 10px 14px; border: 2px solid #F26223; border-radius: 12px; background: #FEF8F6; margin-bottom: 16px; }
    .drives-selected-giver-copy { flex: 1; min-width: 0; }
    .drives-preview-note { background: #F7F8FA; border-radius: 12px; padding: 11px 14px; font-size: 12px; color: #5A6870; margin-bottom: 16px; }
    .drives-dialog-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 6px; }

    .drives-filter-popover-wrap { position: relative; }
    .drives-filter-popover {
      position: absolute; z-index: 20; top: calc(100% + 8px); left: 0; width: 280px; padding: 18px 20px;
      border-radius: 16px; background: white; box-shadow: 0 16px 50px rgba(34,45,50,.22);
      animation: drives-pop-in 160ms ease both;
    }
    .drives-filter-popover-title { font-family: 'Quicksand', sans-serif; font-size: 15px; font-weight: 700; margin-bottom: 12px; }
    .drives-filter-group { margin-bottom: 12px; }
    .drives-filter-group-label { font-family: 'IBM Plex Mono', monospace; font-size: 9.5px; color: var(--dot-muted); letter-spacing: 1px; margin-bottom: 7px; }
    .drives-filter-options { display: flex; flex-wrap: wrap; gap: 6px; }
    .drives-filter-pill {
      background: white; border: 1.5px solid #D6DBE0; color: #5A6870; font-size: 11px; font-weight: 800;
      padding: 4px 11px; border-radius: 99px; cursor: pointer;
    }
    .drives-filter-pill-active { border-color: #F26223; background: #FDE5DA; color: var(--dot-action-text); }
    .drives-filter-footer { display: flex; justify-content: space-between; border-top: 1px solid #F2F4F6; padding-top: 12px; }
    .drives-filter-clear { font-size: 12px; font-weight: 800; color: var(--dot-muted); background: transparent; cursor: pointer; }
    .drives-filter-apply { font-size: 12px; font-weight: 800; color: var(--dot-action-text); background: transparent; cursor: pointer; }

    .drives-move-dialog { width: min(400px, 100%); }
    .drives-move-title { font-family: 'Quicksand', sans-serif; font-size: 17px; font-weight: 700; margin-bottom: 6px; }
    .drives-move-copy { font-size: 13px; color: #5A6870; line-height: 1.6; margin-bottom: 14px; }
    .drives-move-options { display: flex; flex-direction: column; gap: 8px; margin-bottom: 16px; }
    .drives-move-option {
      width: 100%; border: 1px solid #E4E8EC; border-radius: 12px; padding: 11px 14px; display: flex;
      align-items: center; gap: 10px; background: white; cursor: pointer; text-align: left;
    }
    .drives-move-option-selected { border: 2px solid #F26223; background: #FEF8F6; }
    .drives-move-option-copy { flex: 1; min-width: 0; }
    .drives-move-option-title { font-weight: 800; font-size: 13px; }
    .drives-move-option-sub { font-size: 11px; color: var(--dot-muted); }

    .drives-completed-card { border-radius: 20px; background: white; box-shadow: 0 1px 3px rgba(34,45,50,.06); overflow: hidden; }
    .drives-completed-head { padding: 18px 24px; border-bottom: 1px solid #E4E8EC; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; }
    .drives-completed-title-row { display: flex; align-items: center; gap: 12px; }
    .drives-completed-title { font-family: 'Quicksand', sans-serif; font-size: 17px; font-weight: 700; }
    .drives-completed-meta { font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: var(--dot-muted); }
    .drives-completed-list { padding: 10px 24px 18px; }
    .drives-completed-row { display: flex; align-items: center; gap: 12px; padding: 11px 0; border-bottom: 1px solid #F2F4F6; }
    .drives-completed-icon { font-size: 15px; flex: 0 0 auto; }
    .drives-completed-copy { flex: 1; min-width: 0; }
    .drives-completed-name { font-weight: 800; font-size: 13.5px; }
    .drives-completed-sub { font-size: 11px; color: var(--dot-muted); }
    .drives-completed-amount { font-family: 'IBM Plex Mono', monospace; font-size: 13px; font-weight: 500; width: 84px; text-align: right; flex: 0 0 auto; }
    .drives-pagination { display: flex; justify-content: center; gap: 4px; margin-top: 16px; }
    .drives-page-button {
      min-width: 34px; height: 32px; border-radius: 8px; color: var(--dot-muted); background: transparent;
      cursor: pointer; font-size: 13px; font-weight: 800;
    }
    .drives-page-button:hover:not(:disabled) { color: var(--dot-action-text); background: #FDE5DA; }
    .drives-page-button-active { color: white; background: var(--dot-action); }
    .drives-page-button:disabled { cursor: default; opacity: .4; }
    .drives-ellipsis { min-width: 28px; display: grid; place-items: center; color: var(--dot-muted); }

    @keyframes drives-fade-in { from { opacity: 0; } to { opacity: 1; } }
    @keyframes drives-panel-in { from { transform: translateX(40px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
    @keyframes drives-pop-in { from { transform: translateY(14px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

    @media (max-width: 900px) {
      .drives-header-row { flex-wrap: wrap; }
      .drives-financials-row { margin-left: 0; }
      .drives-search { width: 100%; }
    }
    @media (max-width: 620px) {
      .drives-page { min-height: calc(100vh - 88px); }
      .drives-dialog-actions { flex-direction: column; }
      .drives-form-grid { grid-template-columns: 1fr; }
      .drives-dialog { padding: 22px 18px; }
    }
""".trimIndent()

val DrivesStyles = FC<Props> {
    style { +drivesStyles }
}
